module.exports = "./dist/notes-at-icon-512.png?c462dc7779f5ac8a30956e9ce25a728b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/notes-at-icon-512.png
// module id = 245
// module chunks = 0